import React, {ReactElement} from 'react';
import {Props} from './Props';
import DateTimeFormatted from '../../../../../../components/DateTimeFormatted';
import {css} from 'aphrodite/no-important';
import styles from './styles';
import StyledBoolean from '../../../../../../components/StyledBoolean';
import {GeoJsonPropertiesDrip} from '../../../../../../interfaces/GeoJsonSources/GeoJsonPropertiesDrip';
import {isNonEmptyArray, isStringifiedArray} from '../../../../../../utils/ArrayUtil';

class DialogDrip extends React.Component<Props> {
    render(): ReactElement {
        const {currentProperties, showRecordIds} = this.props;

        const hasImage = !!currentProperties.image;
        const hasText = this.hasText(currentProperties);

        return (
            <table>
                <tbody>
                    {showRecordIds && (
                        <tr>
                            <th>ID</th>
                            <td>{currentProperties.id}</td>
                        </tr>
                    )}
                    <tr>
                        <th>Naam</th>
                        <td>{currentProperties.name}</td>
                    </tr>
                    <tr>
                        <th>ID</th>
                        <td>{currentProperties.id}</td>
                    </tr>
                    <tr>
                        <th>Laatste update</th>
                        <td>
                            <DateTimeFormatted dateTime={currentProperties.updatedAt} />
                        </td>
                    </tr>
                    <tr>
                        <th>Actief</th>
                        <td>
                            <StyledBoolean value={hasImage || hasText} />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}>
                            <br />
                        </td>
                    </tr>
                    {this.renderDrip(currentProperties)}
                </tbody>
            </table>
        );
    }

    private readonly hasText = (properties: GeoJsonPropertiesDrip): boolean => {
        if (isStringifiedArray(properties.textLines)) {
            const textLinesArray = JSON.parse(properties.textLines) as string[];
            if(isNonEmptyArray(textLinesArray)) {
                return true;
            }
        }
        return false;
    };

    private readonly renderDrip = (properties: GeoJsonPropertiesDrip) => {
        if (properties.image) {
            return this.renderImage(properties.image, properties.name);
        } else if (this.hasText(properties)) {
            const textLinesArray = JSON.parse(properties.textLines as string) as string[];
            return this.renderLines(textLinesArray);
        }
        return <React.Fragment />;
    };

    private readonly renderLines = (textLines: string[]) => {
        try {

            return (
                <tr className={css(styles.textLine)}>
                    <td colSpan={2} className={css(styles.textLineColumn)}>
                        {textLines.map((text: string) => {
                            return (
                                <React.Fragment key={text}>
                                    {text}
                                    <br />
                                </React.Fragment>
                            );
                        })}
                    </td>
                </tr>
            );
        } catch (e) {
            return <React.Fragment />;
        }
    };

    private readonly renderImage = (image: string, name: string) => {
        return (
            <tr>
                <td colSpan={2} className={css(styles.imageContainer)}>
                    <img
                        src={`data:image/png;base64,${image}`}
                        alt={`Huidig DRIP beeld van ${name}`}
                        title={`Huidig DRIP beeld van ${name}`}
                        className={css(styles.image)}
                    />
                </td>
            </tr>
        );
    };
}

export default DialogDrip;
